import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=0aac3f8d&"
import script from "./LightBox.vue?vue&type=script&lang=ts&"
export * from "./LightBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports